import { createComponent } from '../../Foundation';
import { TextView as view } from './Text.view';
import { TextStyles as styles } from './Text.styles';
export var Text = createComponent({
    displayName: 'Text',
    styles: styles,
    view: view
});
export default Text;
//# sourceMappingURL=Text.js.map